export const is_prod = process.env.NODE_ENV === "production";

export const API_URL = process.env.REACT_APP_API_URL
  ?? "https://ase-vermost-prtl-bcknd-prod.azurewebsites.net";

export const EMAIL_DEBOUNCE_TIMEOUT = 2000; // 2 seconds
